var attachmentDescriptionStyles = {
  root: function root(_ref) {
    var v = _ref.variables;
    return {
      display: 'block',
      fontSize: v.descriptionFontSize,
      fontWeight: v.descriptionFontWeight,
      lineHeight: v.descriptionLineHeight
    };
  }
};
export default attachmentDescriptionStyles;
//# sourceMappingURL=attachmentDescriptionStyles.js.map
